export default __webpack_public_path__ + "static/media/powerup.eabc78c3.mp3";